import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Activity = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevHover, setPrevHover] = useState(false);
  const [nextHover, setNextHover] = useState(false);

  useEffect(() => {
    AOS.init();
  }, []);

  const services = props?.services || [];

  if (services.length === 0) {
    return <p>No services available</p>;
  }

  const currentService = services[currentIndex];
  const iframeHeight = 600; // fixed height for iframe

  // Background style with logo and overlay for readability
  const backgroundStyle = {
    position: "relative",
    backgroundColor: "#f0f4f8",
    padding: "40px 0",
    overflow: "hidden",
  };

  const logoStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "200px",
    height: "200px",
    opacity: 0.1,
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    userSelect: "none",
    zIndex: 0,
  };

  const containerStyle = {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
  };

  // Button styles
  const prevButtonStyle = {
    backgroundColor: prevHover ? "#004085" : "#007bff", // blue shades
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginRight: "10px",
    transition: "background-color 0.3s ease",
  };

  const nextButtonStyle = {
    backgroundColor: nextHover ? "#155724" : "#28a745", // green shades
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? services.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === services.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="services" className="services section light-background" style={backgroundStyle}>
      {/* Background logo */}
      <img src="/logo192.png" alt="Background Logo" style={logoStyle} />

      <div className="container section-title" data-aos="fade-up" style={containerStyle}>
        <h2>{props?.serviceHeader}</h2>
        <p>{props?.description}</p>
      </div>

      <div className="container" style={{ ...containerStyle, marginTop: "20px"}}>
        <iframe
          key={currentIndex}
          src={currentService.src}
          width={currentService.width || "100%"}
          height={currentService.height>iframeHeight?currentService.height:iframeHeight || iframeHeight}
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
          frameBorder={0}
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          title={`facebook-post-${currentIndex}`}
        />

        <div style={{ marginTop: "20px" }}>
          <button
            onClick={goPrev}
            style={prevButtonStyle}
            onMouseEnter={() => setPrevHover(true)}
            onMouseLeave={() => setPrevHover(false)}
          >
            Previous
          </button>
          <button
            onClick={goNext}
            style={nextButtonStyle}
            onMouseEnter={() => setNextHover(true)}
            onMouseLeave={() => setNextHover(false)}
          >
            Next
          </button>
        </div>

        <p style={{ marginTop: "10px" }}>
          Post {currentIndex + 1} of {services.length}
        </p>
      </div>
    </section>
  );
};

export default Activity;
